// Web Vibration API helper — costs nothing on devices that don't
// support it (returns false). Pure no-op outside touch devices so we
// don't surprise desktop users with random pulses.
//
// Touch detection mirrors the rest of the codebase
// (`ontouchstart in window || navigator.maxTouchPoints > 0`).
//
// Used by:
//   - GameCanvas.applyPowerup → short pulse on power-up pickup
//   - GameCanvas ball-brick step → triple pulse on 3+ brick combo
function isTouchDevice() {
  if (typeof window === "undefined") return false;
  return (
    "ontouchstart" in window
    || (typeof navigator !== "undefined" && (navigator.maxTouchPoints || 0) > 0)
  );
}

export function haptic(pattern) {
  try {
    if (!isTouchDevice()) return false;
    if (typeof navigator === "undefined") return false;
    if (typeof navigator.vibrate !== "function") return false;
    return navigator.vibrate(pattern);
  } catch {
    return false;
  }
}

// Pre-baked patterns used by the game so they stay consistent across
// pickup / combo / boss-defeat moments.
export const Haptic = {
  /** Short tactile thump on a single notable event (power-up pickup). */
  tap: () => haptic(20),
  /** Triple-pulse "combo" cue (3+ block streak inside a single frame). */
  combo: () => haptic([20, 50, 20]),
};
